import { render } from "./Typography.vue?vue&type=template&id=a21fba70&scoped=true"
import script from "./Typography.vue?vue&type=script&lang=js"
export * from "./Typography.vue?vue&type=script&lang=js"

import "./Typography.vue?vue&type=style&index=0&id=a21fba70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21fba70"]])

export default __exports__